import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { Cart, SavedCartConfigService } from 'gung-standard';
import { CarLinerSavedCartTableComponent } from '../components/car-liner-saved-cart-table/car-liner-saved-cart-table.component';


@Injectable({
  providedIn: 'root'
})
export class CarLinerSavedCartConfigService extends SavedCartConfigService {
  getLayouts(): ListLayout<Cart>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CarLinerSavedCartTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Product grid'
      }
    ];
  }
}
